import React, { useMemo } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const COLORS = ['#E3B23C', '#1E7F6E', '#C2413B', '#F2F6FA', '#4C8FB8'];
export function Confetti() {
  const reduced = useReducedMotion();
  const pieces = useMemo(() => Array.from({
    length: 44
  }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 0.5,
    duration: 1.6 + Math.random() * 1.1,
    drift: (Math.random() - 0.5) * 90,
    rotate: Math.random() * 360 + 180,
    color: COLORS[i % COLORS.length],
    w: 5 + Math.random() * 4,
    h: 9 + Math.random() * 7
  })), []);
  if (reduced) return null;
  return <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true" data-id="element-65" data-mp="2ej4y87yf24wi">
      {pieces.map(p => <motion.span key={p.id} className="absolute top-[-6%] block rounded-[1px]" style={{
      left: `${p.left}%`,
      width: p.w,
      height: p.h,
      backgroundColor: p.color
    }} initial={{
      y: 0,
      x: 0,
      rotate: 0,
      opacity: 1
    }} animate={{
      y: '110vh',
      x: p.drift,
      rotate: p.rotate,
      opacity: [1, 1, 0]
    }} transition={{
      duration: p.duration,
      delay: p.delay,
      ease: 'linear'
    }} data-id="element-66" data-mp="3byirloiz7b8g" />)}
    </div>;
}